
<div class="nft-lists-comp" style="margin-top: 88px;">
    <section class="filter sticky p-20">
        <div class="row no-gutter ">
            <div class="col-4">
                <div class="s-con">
                    <input type="text" class="s-input" placeholder="Search" [(ngModel)]="searchfil">
                    <i class="fa fa-search"></i>
                </div>
            </div>
            <div class="col-8 text-right button-padding">
                <div class="dropdown">
                    <button class=" d-btn " type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <span class="d-name">{{sortValue ? sortValue : 'Sort By'}}</span>
                        <span class="arrow align-middle"></span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <ng-container *ngFor="let sort of SortDrop">
                            <span class="dropdown-item" (click)="sortData(sort)">{{sort.name}}</span>
                        </ng-container>
                    </div>
                </div>
                <!--  -->
            </div>
        </div>
    </section>
    <ng-container *ngIf="bannerList.length == 0">
        <div class="text-center fs-22 text-light"> No {{filterValue}} Data Available</div>
    </ng-container>
    <section class="card-Sec">
        <div class="cards-con" >
            <ng-container *ngFor="let item of bannerList | filter: searchfil:'organization_name' ;let i = index">
                <div class="cards pointer" (click)="goToChannels($event, item)">
                    <div class="imagediv"
                        [ngStyle]="{'background-image': item.organization_logo ? 'url(' + item.organization_logo + ')' : item.organization_banner ? 'url(' + item.organization_banner + ')': item.channel_logo ? 'url(' + item.channel_logo + ')':'url(assets/clients/bigbeeai/logo.svg)'}">
                    </div>
                    <div class="desc-con ">
                        <div class="desc-h mb-2" matTooltipPosition="above" matTooltip="{{item?.organization_name}}">
                            {{item.organization_name}}</div>
                        <div> 
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </section>
</div>
